import type { CSSProperties } from 'react';

export const CLAIM_TABLE_SURFACE_COLOR = 'var(--mantine-color-body)';

export const claimTableStyles = {
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: 'var(--mantine-spacing-sm)',
    width: '100%',
  } satisfies CSSProperties,
  leadingActions: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 'var(--mantine-spacing-xs)',
  } satisfies CSSProperties,
  internalActions: {
    marginLeft: 'auto',
  } satisfies CSSProperties,
  header: {
    background: CLAIM_TABLE_SURFACE_COLOR,
  } satisfies CSSProperties,
};
